import { KatNavigation } from '@amzn/katal-react';
import React from 'react';
import { Outlet } from 'react-router';
import { useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { ADMIN_PANEL_NAVIGATION_CONSTANTS } from 'src/constants/AdminConstants';
import {
  ADMIN_CHILD_ROUTES,
  ADMIN_PAGE_ROUTE,
} from 'src/constants/UrlConstants';
import styled from 'styled-components';

const AdminLayout = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

export const AdminPageContentLayout = styled.div`
  width: 50vw;
  min-width: 40rem;
  align: center;
`;

export const Admin = () => {
  const { pathname, search } = useLocation();

  const appendRedirectParam = (path: string) => {
    const params = new URLSearchParams(search);
    const redirectTo = params.get('redirectTo');
    if (redirectTo) {
      return `${path}?redirectTo=${encodeURIComponent(redirectTo)}`;
    }
    return path;
  };

  return (
    <AdminLayout>
      <KatNavigation
        mode="vertical"
        label={ADMIN_PANEL_NAVIGATION_CONSTANTS.NAVIGATION_HEADER_NAME}
      >
        <NavLink
          to={appendRedirectParam(ADMIN_PAGE_ROUTE)}
          {...(pathname === ADMIN_CHILD_ROUTES.ADD_USER_PAGE.pageUrl && {
            'data-active': true,
          })}
        >
          {ADMIN_PANEL_NAVIGATION_CONSTANTS.ADD_USER_PAGE_LINK_NAME}
        </NavLink>
        <NavLink
          to={appendRedirectParam(ADMIN_CHILD_ROUTES.LIST_PAGE.relativeUrl)}
          {...(pathname === ADMIN_CHILD_ROUTES.LIST_PAGE.pageUrl && {
            'data-active': true,
          })}
        >
          {ADMIN_PANEL_NAVIGATION_CONSTANTS.LIST_USER_PAGE_LINK_NAME}
        </NavLink>
      </KatNavigation>
      <AdminPageContentLayout>
        <Outlet />
      </AdminPageContentLayout>
    </AdminLayout>
  );
};
